// extracted by mini-css-extract-plugin
module.exports = {"dot-flashing":"style_dot-flashing__E9a0b","text":"style_text__SHKQS","avatar":"style_avatar__itHmY","dot-flashing-avatar":"style_dot-flashing-avatar__EyRcd"};